<template>
  <div class="wrapper wrapper_wide section_content">
    <div class="frame_center">
      <div class="blk_feature">
        <div class="feature_photo"><img src="/assets/img/contact/img_contact.png" alt=""></div>
      </div>
      <Consultation :mail="false"/>
      <Form />
    </div>
  </div>
</template>

<script>
// organisms
import Consultation from '../organisms/consultation.vue'
import Form from '../organisms/form.vue'

export default {
  name: 'ContactContents',
  components: {
    Consultation,
    Form
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
